import { UIKitIcon } from '../icon';

export const preferencesIcon: UIKitIcon = {
  name: 'preferences',
  // tslint:disable-next-line: max-line-length
  data: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="32" height="32" viewBox="0 0 32 32">'
  + '<g><path d="M8.6,12.9h0A1.714,1.714,0,0,1,7,14H6.2A12.31,12.31,0,0,0,6,16a12.31,12.31,0,0,0,.2,2H7a1.781,1.781,0,0,1,1.6,1h0a1.714,'
  + '1.714,0,0,1-.4,1.9l-.6.6a9.346,9.346,0,0,0,2.8,2.8l.6-.6a1.866,1.866,0,0,1,1.9-.4h0a1.781,1.781,0,0,1,1,1.6v.8a12.31,12.31,0,0,0,2,'
  + '.2,12.31,12.31,0,0,0,2-.2V25a1.781,1.781,0,0,1,1-1.6h0a1.714,1.714,0,0,1,1.9.4l.6.6a9.346,9.346,0,0,0,2.8-2.8l-.6-.6a1.866,1.866,0,'
  + '0,1-.4-1.9h0a1.781,1.781,0,0,1,1.6-1h.8a12.31,12.31,0,0,0,.2-2,12.31,12.31,0,0,0-.2-2H25a1.781,1.781,0,0,1-1.6-1h0a1.714,1.714,0,0,1'
  + ',.4-1.9l.6-.6a9.346,9.346,0,0,0-2.8-2.8l-.6.6a1.866,1.866,0,0,1-1.9.4h0a1.781,1.781,0,0,1-1-1.6v-1A14.919,14.919,0,0,0,16,6a12.31,'
  + '12.31,0,0,0-2,.2V7a1.781,1.781,0,0,1-1,1.6h0a1.714,1.714,0,0,1-1.9-.4l-.6-.6a9.346,9.346,0,0,0-2.8,2.8l.6.6A1.911,1.911,0,0,1,8.6,'
  + '12.9Z" fill="none" stroke="inherit" stroke-miterlimit="10" stroke-width="1"/><circle cx="2" cy="2" r="2" transform="translate(14 14)" '
  + 'fill="none" stroke="inherit" stroke-miterlimit="10" stroke-width="1"/></g></svg>',
};
